<template>
  <div>
    <v-sheet outlined class="pa-2 ma-2 d-flex align-center">
      <div v-if="!isDetail">
        <!-- title -->
        <span class="primary--text font-weight-bold"> {{ dayjs().year() }}년</span>
        <span class="font-weight-bold mx-2">총 회원</span>
        <span class="text-h6 mx-4">{{ $toComma(totalAmount || 0) }} 명</span>
      </div>
      <div v-else>
        <v-btn depressed @click="prev" color="white"><v-icon> mdi-arrow-left </v-icon></v-btn> {{ selectedMonth + 1 }}월
      </div>
    </v-sheet>

    <!-- 본문 -->
    <v-sheet outlined class="pa-2 ma-2" width="800">
      <v-data-table v-show="!isDetail" :headers="listTableHeaders" :items="list_items" hide-default-footer :items-per-page="-1" :loading="isLoading" loading-text="Loading... Please wait">
        <template v-slot:[`item.date`]="{ item }">
          <span>{{ Number(item.date.split("-")[1]) }}월</span>
        </template>
        <template v-slot:[`item.new_user`]="{ item }">
          <span>{{ $toComma(Number(item.new_user)) }}</span>
        </template>
        <template v-slot:[`item.not_sns_user`]="{ item }">
          <span>{{ $toComma(Number(item.not_sns_user)) }}</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn small depressed color="primary" outlined @click="openDetail(item)">내역보기</v-btn>
        </template>
      </v-data-table>

      <v-sheet v-if="isDetail" class="pb-10">
        <v-sheet v-if="isLoading">
          <span>Loading... Please wait</span>
        </v-sheet>
        <v-simple-table v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th>{{ selectedMonth + 1 }}월</th>
                <th>신규 회원</th>
                <th>이메일 가입자</th>
              </tr>
            </thead>
            <tbody>
              <tr class="accentBg">
                <td class="text-center">계</td>
                <td>{{ selectedItem.new_user }}</td>
                <td>{{ selectedItem.not_sns_user }}</td>
              </tr>
              <tr v-for="(item, index) in detail_items" :key="index">
                <td :class="{ 'red--text': dayjs(item.date).day() === 0 || dayjs(item.date).day() === 6 }">{{ dayjs(item.date).format("D") }}일</td>
                <td>{{ item.new_user }}</td>
                <td>{{ item.not_sns_user }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-sheet>
    </v-sheet>
  </div>
</template>
<script>
import statusService from "@/api/stats-service"
export default {
  data: () => ({
    isLoading: false,
    isDetail: false,
    selectedMonth: 1,
    selectedItem: null,
    list_items: [],
    detail_items: [],
    totalAmount: 0,
    listTableHeaders: [
      { value: "date", text: "날짜", width: "80px" },
      { value: "new_user", text: "신규 회원", align: "right" },
      { value: "not_sns_user", text: "이메일 가입자", align: "right" },
      { value: "actions", text: "세부내역", width: "200px", sortable: false },
    ],
  }),
  created() {
    this.selectedMonth = this.dayjs().month()
  },
  mounted() {
    this.loadList()
  },
  methods: {
    async loadList() {
      try {
        console.log("review stats")
        this.isLoading = true

        let from = this.dayjs().startOf("year").format("YYYY-MM-DD")
        let to = this.dayjs().format("YYYY-MM-DD")

        let result = await statusService.getUserStats(true, from, to)
        result.sort((a, b) => Number(a.date.split("-")[1]) - Number(b.date.split("-")[1]))
        this.list_items = result

        this.totalAmount = await statusService.getUserCount()
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },

    async loadDetail(month) {
      this.detail_items = []
      try {
        this.isLoading = true

        let fromDayjs = this.dayjs().month(month).startOf("month")
        let toDayjs = fromDayjs.endOf("month")

        const from = fromDayjs.format("YYYY-MM-DD")
        const to = toDayjs.format("YYYY-MM-DD")

        let result = await statusService.getUserStats(false, from, to)
        result.sort((a, b) => this.dayjs(a.date) - this.dayjs(b.date))

        this.detail_items = this._getStructItems(fromDayjs, toDayjs, result)
        console.log(this.detail_items)
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },

    openDetail(item) {
      this.selectedMonth = Number(item.date.split("-")[1]) - 1
      this.selectedItem = item
      this.isDetail = true
      this.loadDetail(this.selectedMonth)
    },
    prev() {
      this.isDetail = false
      this.selectedItem = null
    },

    _getStructItems(from, to, infos) {
      const diffDay = to.diff(from, "day")
      return [...Array(diffDay + 1).keys()].map((e) => {
        const date = from.add(e, "day")

        const infoValue = infos.find((e) => e.date === date.format("YYYY-MM-DD"))
        let eachItem = {
          new_user: 0,
          not_sns_user: 0,
        }
        if (infoValue) {
          eachItem = infoValue
        }

        return {
          ...eachItem,
          dateStr: date.format("YYYY-MM-DD"),
          date,
        }
      })
    },
  },
}
</script>
<style scoped>
.greyBg {
  background-color: rgb(220, 220, 220);
}

.accentBg {
  background-color: rgb(220, 182, 220);
}
</style>
